import React from "react";

import { getLocations, getStatesNames } from "../../data";
import SelectVariants from "../Select";
import { useLocation, useLocationUpdate } from "../../contexts/LocationContext";

const SelectLocation = ({ withLabel = true, small = false }) => {
  const location = useLocation()
  const setLocation = useLocationUpdate()

  const locations = getLocations();
  const statesNames = getStatesNames()

  const defaultValue = "US";
  const name = "LOCATION";
  const options = locations.map((l) => {
    return {
      value: l.toString(),
      label: statesNames[l],
    };
  });

  return (
    <SelectVariants
      withLabel={withLabel}
      small={small}
      name={name}
      field={location}
      setField={setLocation}
      options={[{ value: "US", label: "the U.S." }, ...options]}
      defaultValue={defaultValue}
    />
  );
};

export default SelectLocation;
